import React, { useState, useEffect, useContext, useRef, useMemo, startTransition } from "react";
import _ from "lodash";
import {
  getPhenomenaTypes,
  getGroupById,
  getRadar,
} from "@futures-platform/connectors/drupal-api";
import Tooltip from '@mui/material/Tooltip'
import checked from "./components/CardHeader/checked.svg";
import g1 from "./components/CardHeader/greyscale-regular@2x.png";
import trans from "./components/CardHeader/trans.svg";
import orginalTrans from "./components/CardHeader/orignalTrans.svg";
import Markdown from 'react-markdown'
import arrow from "./components/CardHeader/arrow.svg";
import { getSessionToken, getUserId } from "@futures-platform/connectors/session";
import { normalizeGroup } from "@futures-platform/connectors/drupal-api/normalize";
import { screenshot } from '@futures-platform/connectors/screenshot-service-api'
import {
  getPhenomena,
  getContentCardData,
  getPhenomenonNewsByPhenId,
  getPhenomenaStatistic,
} from "./helpers/phenomenonFetcher";
import YoutubeImageEmbed from "./components/YoutubeImageEmbed";
import LatestNewsCarousel from "./components/LatestNewsCarousel";
import Comments from "./components/Comments";
import CardHeader from "./components/CardHeader";
import BodyCard from "./components/CardBody";
import RelatedPhenomena from "./components/RelatedPhenomena";
import LatestNews from "./components/LatestNews";
import CardFooter from "./components/CardFooter";
import Links from "./components/Links";
import Rating from "./components/Rating/Rating";
import styled from "styled-components";
import ToggleSwitcher from "./components/PhenEditForm/ToggleSwitcher";
import { PhenomenonEditForm } from "./components/PhenEditForm/PhenomenonEditForm";
import {
  Modal,
  // paddingModalStyles,
} from "@futures-platform/ui";
import { PhenEditCardStyles } from "./styles";
import { DataContext } from "./store/GlobalState";
import { ACTIONS } from "./store/Actions";
import useSWR, { SWRConfig } from "swr";
import { getCloseButton } from "./helpers/helpers";
// import {commentingApi} from './helpers/commentingFetcher'
// import { getUserId } from '@futures-platform/connectors/session'
import { getAllCommentsByPhenId } from "./helpers/utils";
import { votingApi } from "./helpers/fetcher";
// import styled from 'styled-components'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getDocuments } from "@futures-platform/connectors/content-service-api";
import RelatedScenarios from "./components/RelatedScenarios";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./components/LatestNews/LatestNews.module.css";
import { requestTranslation } from "@futures-platform/i18n";
import { normalisedTimeFormat } from "./helpers/helpers";
import {
  Dropdown,
  DropdownValue,
} from "./components/PhenEditForm/PhenomenonEditForm";
import ContactSupportForm from "./components/ContactSupportForm";
import Voting from "./components/Voting/Voting";
import TranslationBtn from "./components/TranslationBtn";
import TranslationDownBtn from "./components/TranslationDownBtn";
import SpotlightBtn from "./components/SpotlightBtn";
import BookmarkBtn from "./components/BookmarkBtn";
import ShareBtn from "./components/ShareBtn";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import useOnClickOutside from "./hooks/useOnClickOutside";
import { PhenomenaTagList } from "./components/PhenomenaTagList";
import {isPublicShare} from '@futures-platform/connectors/session'
import { translatePhenomenonAlias } from "./helpers/utils";
import PDFBtn from "./components/PDFBtn";
import { getNewsFeedData } from "./helpers/phenomenonFetcher";
import { setupPostMessageListener, parseStatzonChartUrl, buildStatzonChartUrl } from "./utils/postMessageUtils";
import { extractTagValues , getTagValues } from "./helpers/helpers";
import ErrorNotice from "./components/ErrorNotice";
const specialGroupsAllowedTranslation = [
  
]
const App = ({ gid: gidProp, rid, pid, position, groupRadarId, uri }) => {
  NProgress.configure({ minimum: 0.1 });
  const mainContentCard = useRef();
  const relatedPhenOnAppRef = useRef();
  const cmtRef = useRef();
  const sharedBtnRef = useRef();
  const hostname = window?.location?.origin;
  const {
    state: { isTranslated, langForTransState, isAutoTrans, langListOpts, tags, dataForTranslationFromCardHeader, dataForTranslationCardBody , contentTypeImageSrc, crowdsourced, pdfExportLoading, publicPhenomenaGroupsActived, thirdPartyPhenomenaGroupsActived, userGroups , radarId},
    dispatch, 
  } = useContext(DataContext);

  const gid = useMemo(() => Number(gidProp), [gidProp])

  useEffect(() => {
    dispatch({ type: ACTIONS.SET_RADAR_ID, payload: rid }); 
  }, [dispatch, rid]);

  const langOptionList = useMemo(() => {
    if (!!langListOpts?.length) {
      return langListOpts?.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    } else return [];
  }, [langListOpts]);
  const historyWrapperRef = useRef();
  const historyWrapper2Ref = useRef();
  const [shouldNotShowPdfExportBtn, setshouldNotShowPdfExportBtn] =
  useState(false)
  const [openPhenEditCard, setOpenPhenEditCard] = useState(null);
  const [scenariosState, setscenariosState] = useState([]);
  const [langForTransTemp, setlangForTransTemp] = useState(langForTransState);

  const [iconNewsFeedSection, seticonNewsFeedSection] = useState("expand_more");
  const [historyOrignalDataState, sethistoryOrignalDataState] = useState([]);
  const [isOpenTransSettings, setisOpenTransSettings] = useState(false);
  const [isAutoTransTemp, setisAutoTransTemp] = useState(isAutoTrans);
  const [isNewsBookMarked, setisNewsBookMarked] = useState(false);
  const [isSharedModalOpened, setisSharedModalOpened] = useState(false);
  const [statzonChartType, setStatzonChartType] = useState('');
    const [isExpandedUpdateRecommended, setisExpandedUpdateRecommended] = useState(false)
  const shareWrapperRef = useRef();
  const firstRender = useRef(true);
  const [error, setError] = useState(null)
  const isFetchedcompletedPhenomenonDataRef = useRef(false);
  const isFetched3rdPartyPhenomenonDataRef = useRef(false);

  useEffect(() => {
    if (firstRender.current && !!langForTransState && typeof isAutoTrans !== "undefined") {
      firstRender.current = false;
      if (langForTransTemp !== langForTransState) {
        setlangForTransTemp(langForTransState);
      }
      if (isAutoTransTemp !== isAutoTrans) {
        setisAutoTransTemp(isAutoTrans);
      }
      return;
    }
    
  }, [langForTransState, isAutoTrans])

  const handleChangeIconNewsFeedSection = () => {
    if (iconNewsFeedSection === "expand_more")
      seticonNewsFeedSection(() => `expand_less`);
    else {
      seticonNewsFeedSection(() => `expand_more`);
    }
  };
  NProgress.start();
  NProgress.set(0.2);
  const groupIdUsed = React.useMemo(() => {
    return groupRadarId;
  }, [groupRadarId]);

  useEffect(() => {
    dispatch({
      type: ACTIONS.GROUPRADARID,
      payload: groupIdUsed,
    });
  }, [dispatch, groupIdUsed]);

  const { data, mutate: mutateContentCard } = useSWR(
    `getAllCommentsByPhenId=${groupIdUsed}/${rid}/${pid}`,
    async () => {
      // const groups = [...new Set([0, Number(gid)])]
      try {
        const [
          // phenomenon,
          phenomenonType,
          allCmtsData,
          newsFeed,
          getPhenomenaData,
          getGroupByIdData,
          getRadarData,
          getStatus1BookmarkNews,
        ] = await Promise.all([
          // getContentCardData(Number(gid) || 0, pid),
          getSessionToken() ? getPhenomenaTypes(gid || 0) : Promise.resolve(null),
          (!!pid && !!rid
            ? getAllCommentsByPhenId(groupIdUsed || gid, rid, pid)
            : Promise.resolve(null)
          ).catch((err) => {
            console.error("Error fetching allCmtsData:", err);
            return null;
          }),
          // null,
          getNewsFeedData(gid || 0, pid).catch(() => null),
          getPhenomena({
            phenomena: [pid],
            undefined,
            groups: [Number(gid) || 0],
            include_archived: rid ? true : false,
          }),
          getGroupById(gid || 0),
          !!pid && !!rid && getRadar(rid),
          votingApi
            .getStatus1BookmarkNews(`${gid || 0}/phenomenon/${pid}`)
            .catch((err) => {
              console.error("Error fetching getStatus1BookmarkNews:", err);
              return { data: [] };
            }),
        ]);
        const bookmarkRows = Array.isArray(getStatus1BookmarkNews?.data)
          ? getStatus1BookmarkNews.data
          : [];
        const bookmarkEntityUriSplited = bookmarkRows[0]?.entityUri?.split("/");

        const newsIdFromEntityUriRes = !!bookmarkEntityUriSplited
          ? bookmarkEntityUriSplited[4]
          : false;

        if (!!newsIdFromEntityUriRes && newsIdFromEntityUriRes === pid) {
          setisNewsBookMarked(true);
        } else {
          setisNewsBookMarked(false);
        }
        dispatch({
          type: ACTIONS.GETRADARDATAACTION,
          payload: getRadarData,
        });

        dispatch({
          type: ACTIONS.CMTSDATA,
          payload: allCmtsData?.data,
        });

        dispatch({
          type: ACTIONS.CONTENTTYPES,
          payload: phenomenonType,
        });
        const groupNormalized =
          !!getGroupByIdData &&
          !!getGroupByIdData?.length &&
          (await Promise.all(
            getGroupByIdData?.map((group) => {
              return normalizeGroup(group);
            })
          ));

        dispatch({
          type: ACTIONS.CONTENTSETTINGS,
          payload: groupNormalized,
        });

        if (getPhenomenaData?.result?.[0]) {
          getPhenomenaData.result[0].newsFeeds = newsFeed;
        }
        const phenTemp = {
          data: {
            ...(!!getPhenomenaData?.result?.length ? getPhenomenaData.result[0] : []), // Check if result is null
          }
        }

        return {
          phenomenon: phenTemp,
          phenomenonType,
          allCmtsData,
          // newsFeed,
          getPhenomenaData,
          groupNormalized,
          getRadarData,
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        NProgress.set(1);
        NProgress.done(true);
        NProgress.remove();
        setError(error || "An unexpected error occurred. Please try again later.");
      }
    }
  );

  const publicPhenomenaGroups = useMemo(() => {
    const groupZero = { id: 0, label: requestTranslation("public") };
    
    if (!publicPhenomenaGroupsActived?.length) {
      return [groupZero];
    }

    if (!data?.groupNormalized?.length) {
      const allPublicDrupalGroups = publicPhenomenaGroupsActived.filter(pg => pg.id !== 0);
      return [groupZero, ...allPublicDrupalGroups];
    }
    
    const groupsStateIds = new Set(data?.groupNormalized.map(group => group.id));
    
    const filteredPublicGroups = publicPhenomenaGroupsActived.filter(
      publicGroup => publicGroup.id !== 0 && !groupsStateIds.has(publicGroup.id)
    );
    
    return [groupZero, ...filteredPublicGroups];
  }, [data?.groupNormalized, publicPhenomenaGroupsActived]); 

  const privatePhenomenaGroups = useMemo(() => {
    if (!data?.groupNormalized || !Array.isArray(data?.groupNormalized)) {
      return [];
    }
    return data?.groupNormalized.filter(group => group.id !== 0);
  }, [data?.groupNormalized]);
   const isPublicGroup = (groupId, publicPhenomenaGroups = [], privatePhenomenaGroups = []) => {
    if (groupId === 0) return true;
    
    const publicGroupIds = publicPhenomenaGroups.map(group => group.id);
    const privateGroupIds = privatePhenomenaGroups.map(group => group.id);
    
    if (publicGroupIds.includes(groupId)) return true;
    if (privateGroupIds.includes(groupId)) return false;
    
    return false;
  };

  const isGet_isThisPhenIsPublicRef = useRef(false);
  const isGet_isThisPhenIsPublicRef2 = useRef(false);


  const isCurrentGroupPublicButNotGroupZero = useMemo(() => {
    if (data?.groupNormalized && !!data?.groupNormalized?.length
      && !!publicPhenomenaGroups?.length && !!privatePhenomenaGroups?.length
    ) {
      const currentGroupId = gid
      if (currentGroupId === 0 || !currentGroupId) {
        isGet_isThisPhenIsPublicRef.current = true;
        return false
      }
        // If currentGroupId exists in groupsData (private groups), return false
      if (data?.groupNormalized?.some(g => g?.id === currentGroupId)) {
          isGet_isThisPhenIsPublicRef.current = true;
          return false;
        }
      isGet_isThisPhenIsPublicRef.current = true;
      return isPublicGroup(currentGroupId, publicPhenomenaGroups, privatePhenomenaGroups);
    }
  }, [gid, data?.groupNormalized, publicPhenomenaGroups, privatePhenomenaGroups]);

  const startTimeWhenPhenEditCardOpenedRef = useRef(null);
  const isAddedPostHogEventForPhenCardForCloseButtonRef = useRef(false);
  const isThisPhenIsPublic = useMemo(() => {
    if (!!data?.getPhenomenaData?.result?.length && !!isGet_isThisPhenIsPublicRef.current && !isGet_isThisPhenIsPublicRef2.current) {
      isGet_isThisPhenIsPublicRef2.current = true;
      return isCurrentGroupPublicButNotGroupZero && !!data?.getPhenomenaData?.result?.length && data?.getPhenomenaData?.result[0]?.isPublic
    }
  }, [data?.getPhenomenaData, isCurrentGroupPublicButNotGroupZero]);
  const thirdPartyContentPosthogEvent = async (content, type) => {
    if (window.posthog) {
      const res = await votingApi.getUserGroups()
      dispatch({ type: ACTIONS.SET_USER_GROUPS, payload: res?.data })
      let groups = thirdPartyPhenomenaGroupsActived
      await Promise.all(res?.data?.map(async (group) => {
        const res2 = await votingApi.getAllThirdPartyPhenomenaGroups(group.id)
        res2?.data?.phenomena?.forEach(pg => {
          if (!groups.find(g => g.id === pg.id)) {
            groups.push(pg)
          }
        })
      }))
      dispatch({ type: ACTIONS.SET_3RD_PARTY_PHENOMENA_GROUPS, payload: groups })
      
      const name_tags = extractTagValues(content.tags)
      let tracking = {
        id: content.id,
        name: content.content?.title,
        phen_type: type,
        group_id: content.groups[0],
        group_name: thirdPartyPhenomenaGroupsActived?.find(group => group.id === content.groups[0]) ? thirdPartyPhenomenaGroupsActived?.find(group => group.id === content.groups[0])?.name : 'Third Party Phenomena Group',
        public: content.isPublic,
        tags: name_tags,
        publish_date: content.created_at,
        timestamp: startTimeWhenPhenEditCardOpenedRef.current.toISOString()
      }
      window.posthog.capture('phenomena-viewed', tracking);
  
      content.tags?.forEach(tag => {
        let tagValues = getTagValues(tag)
        let tracking = {
          name: tagValues.name,
          tag_type: tagValues.type,
          type: 'phenomenom',
          group_id: content.groups[0],
          group_name: thirdPartyPhenomenaGroupsActived?.find(group => group.id === content.groups[0]) ? thirdPartyPhenomenaGroupsActived?.find(group => group.id === content.groups[0])?.name : 'Third Party Phenomena Group',
          phen_name: content.content?.title,
          timestamp: startTimeWhenPhenEditCardOpenedRef.current.toISOString()
        }
        window.posthog.capture('tag-viewed', tracking);
      })
    }
  }
  
  useEffect(() => {
    startTransition(() => { 
    if (!window.posthog) return;
    if (!!data?.getPhenomenaData?.result?.length && data?.getPhenomenaData?.result[0]?.isPublic) {
      if (!startTimeWhenPhenEditCardOpenedRef.current) {
        startTimeWhenPhenEditCardOpenedRef.current = new Date()
        if (window.posthog) {
          if (data?.getPhenomenaData?.result[0]?.groups[0] > 0) {
            thirdPartyContentPosthogEvent(data?.getPhenomenaData?.result[0], completedPhenomenon['content-type-title'])
          } else {
            const name_tags = extractTagValues(data?.getPhenomenaData?.result[0]?.tags)
            let tracking = {
              id: data?.getPhenomenaData?.result[0]?.id,
              name: data?.getPhenomenaData?.result[0]?.content?.title,
              phen_type: completedPhenomenon['content-type-title'],
              group_id: data?.getPhenomenaData?.result[0]?.groups[0],
              group_name: 'Futures Platform',
              public: data?.getPhenomenaData?.result[0]?.isPublic,
              tags: name_tags,
              publish_date: data?.getPhenomenaData?.result[0]?.created_at,
              timestamp: startTimeWhenPhenEditCardOpenedRef.current.toISOString()
            }
            window.posthog.capture('phenomena-viewed', tracking);
  
            data?.getPhenomenaData?.result[0]?.tags?.forEach(tag => {
              let tagValues = getTagValues(tag)
              let tracking = {
                name: tagValues.name,
                tag_type: tagValues.type,
                type: 'phenomenom',
                group_id: data?.getPhenomenaData?.result[0]?.groups[0],
                group_name: 'Futures Platform',
                phen_name: data?.getPhenomenaData?.result[0]?.content?.title,
                timestamp: startTimeWhenPhenEditCardOpenedRef.current.toISOString()
              }
              window.posthog.capture('tag-viewed', tracking);
            })
          }
        }

      }

      if (!isAddedPostHogEventForPhenCardForCloseButtonRef.current) {

        const closeButton = getCloseButton('side-modal', 'side-modal-close-btn', 'phen-card-app-loaded');

        if (!!closeButton && window.posthog) {
          const triggerCloseButtonForPostHog = () => {
            isAddedPostHogEventForPhenCardForCloseButtonRef.current = true;
            let tracking = {
              id: data?.getPhenomenaData?.result[0]?.id,
              name: data?.getPhenomenaData?.result[0]?.content?.title,
              time:(new Date().getTime() - startTimeWhenPhenEditCardOpenedRef.current.getTime()) / 1000,
              timestamp: startTimeWhenPhenEditCardOpenedRef.current.toISOString()
            }
            if (window.location.href.indexOf("go2.futuresplatform.com") !== -1) {
              window.posthog.capture('phenomena-duration', tracking);
            } else {
              // console.log({posthog: {
              //   event: 'phenomena-duration',
              //   properties: tracking
              // }});
            }
            closeButton.removeEventListener('click', triggerCloseButtonForPostHog);
          }
          closeButton.addEventListener('click', triggerCloseButtonForPostHog);
        }
      }
     
    }
    })
  }, [data?.getPhenomenaData, isThisPhenIsPublic]);

  // Get original StatZon chart URL from data
  const originalStatzonChartUrl = useMemo(() => {
    return data?.phenomenon?.data?.content?.media?.statzonChart;
  }, [data?.phenomenon?.data?.content?.media?.statzonChart]);
  
  // Parse the StatZon chart URL to get base URL
  const statzonChartUrlBase = useMemo(() => {
    const { baseUrl } = parseStatzonChartUrl(originalStatzonChartUrl);
    return baseUrl;
  }, [originalStatzonChartUrl]);
  
  // Computed StatZon chart URL with type from postMessage (if available)
  const statzonChartUrl = useMemo(() => {
    // Always use original URL as fallback
    if (!statzonChartUrlBase || !originalStatzonChartUrl) return originalStatzonChartUrl;
    
    // Only modify URL if we have a valid chart type from postMessage
    return statzonChartType 
      ? buildStatzonChartUrl(statzonChartUrlBase, statzonChartType)
      : originalStatzonChartUrl;
  }, [statzonChartUrlBase, statzonChartType, originalStatzonChartUrl]);
  
  // Set up postMessage listener for StatZon chart type
  useEffect(() => {
    if (!originalStatzonChartUrl) return;
    
    // Log all incoming messages for debugging
    // const debugHandler = (event) => {
    //   console.log('Message received:', event.data);
    // };
    // window.addEventListener('message', debugHandler);
    
    // Set up listener for Statzon chart type
    const cleanup = setupPostMessageListener('Statzon-chart-type', (data) => {
      // Only update state if the type is actually changing
      if (data.chartType && data.chartType !== statzonChartType) {
        setStatzonChartType(data.chartType);
      }
    });
    
    return () => {
      cleanup();
      // window.removeEventListener('message', debugHandler);
    };
  }, [originalStatzonChartUrl, statzonChartType]);

  const historyLogsState = useMemo(() => {
    return !!data?.phenomenon?.data?.content?.historyLogs?.length
      ? data?.phenomenon?.data?.content?.historyLogs
      : !!data?.phenomenon?.data?.content?.history?.length
      ? data?.phenomenon?.data?.content?.history
      : [];
  }, [data?.phenomenon?.data?.content]);

  useEffect(() => {
    const fetcher = async () => {
      if (true) {
        let [res, res1] = []
        if (gid === 0) {
         
        } else {
          [res, res1] = await Promise.all([
            votingApi.getUserName(data?.phenomenon?.data?.["created_by"]),
            votingApi.getUserName(data?.phenomenon?.data?.["updated_by"]),
          ])
        }
        const tempDate = normalisedTimeFormat(
          data?.phenomenon?.data?.["created_at"],
          false
        );
        const tempDate1 = normalisedTimeFormat(
          data?.phenomenon?.data?.["updated_at"],
          false
        );
        const temp1 = [
          {
            isMajorUpdate: true,
            description: "",
            isCreator: true,
            editorName: gid === 0 ? "Futures Platform" : res?.data?.displayName ?? "",
            isShown: true,
            date: tempDate,
            id: new Date(data?.phenomenon?.data?.["created_at"]).getTime(),
            timestamp: new Date(
              data?.phenomenon?.data?.["created_at"]
            ).getTime(),
          },
          {
            isMajorUpdate: true,
            description: "",
            isCreator: false,
            editorName: gid === 0 ? "Futures Platform" : res1?.data?.displayName ?? "",
            isShown: true,
            date: tempDate1,
            id: new Date(data?.phenomenon?.data?.["updated_at"]).getTime(),
            timestamp: new Date(
              data?.phenomenon?.data?.["updated_at"]
            ).getTime(),
          },
        ]?.sort((a, b) => b?.timestamp - a?.timestamp);
        sethistoryOrignalDataState(() => temp1);
      }
    };
    if (!!data?.phenomenon?.data && !historyLogsState?.length) {
      fetcher();
    }
  }, [data?.phenomenon?.data, historyLogsState, gid]);

  useEffect(() => {
    const fetcher = async () => {
      if (true) {
        const userId = getUserId();
        const isPublicShareVar = isPublicShare();

        const [res1, res2] = await Promise.all([
          votingApi.getUserName(userId),
          votingApi.getListLangs(),
        ]);

        dispatch({
          type: ACTIONS.LANGFORTRANSSTATE,
          payload: res1?.data?.preferredLanguage,
        });
        
        dispatch({
          type: ACTIONS.LANGLISTOPTIONS,
          payload: res2?.data || [],
        });
        
        if (!!isPublicShareVar) {
          const payload = {
            is_auto_translation: 0,
          };
            await votingApi.editPreferredTrans(userId, payload);
            dispatch({
              type: ACTIONS.ISAUTOTRANS,
              payload: 0,
            });
        } else {
          dispatch({
            type: ACTIONS.ISAUTOTRANS,
            payload: res1?.data?.isAutoTranslation,
          });
        }
      }
    };

    fetcher();
  }, []);

  const historyData = React.useMemo(() => {
    if (!historyLogsState?.length) {
      return [...historyOrignalDataState]?.sort(function (a, b) {
        return b?.timestamp - a?.timestamp;
      });
    }
    const temp = !!historyLogsState?.length
      ? [...historyLogsState]?.sort(function (a, b) {
          return b?.timestamp - a?.timestamp;
        })
      : [];
    return temp;
  }, [historyLogsState, historyOrignalDataState]);

  useEffect(() => {
    const fetcher = async () => {
      const res = await getDocuments({
        type: "scenario-card",
        ids: data?.phenomenon?.data?.content?.related_scenarios,
        fields: null,
        sortColumns: null,
      });
      const res2 = res?.sort(function (a, b) {
        return (
          data?.phenomenon?.data?.content?.related_scenarios?.indexOf(a?.id) -
          data?.phenomenon?.data?.content?.related_scenarios.indexOf(b?.id)
        );
      });
      setscenariosState(() => res2);
    };
    !!data?.phenomenon?.data?.content?.related_scenarios?.length && fetcher();
  }, [data?.phenomenon]);
  !!data && NProgress.set(0.5);

  const phenomenonData = React.useMemo(() => {
    return data?.phenomenon?.data;
  }, [data?.phenomenon?.data]);

  const langRadar = React.useMemo(() => {
    return data?.phenomenon.data?.language;
  }, [data?.phenomenon?.data?.language]);

  const phenomenonTypesData = React.useMemo(() => {
    return data?.phenomenonType;
  }, [data?.phenomenonType]);

  const phenomenonTypeData = React.useMemo(() => {
    return !!data?.phenomenonType?.length &&
      !!data?.phenomenon?.data?.content?.type
      ? data?.phenomenonType?.filter(
          (type) => type?.id === data?.phenomenon?.data?.content?.type
        )
      : [];
  }, [data?.phenomenon?.data?.content?.type, data?.phenomenonType]);

  const closeSocialBtnsHAndler = () => {
    setisSharedModalOpened(false);
  };

  const isFPEditorRole = useMemo(() => {
    const IsHaveCanEditPublic =
    !!data?.groupNormalized?.length &&
    data?.groupNormalized?.filter((gr) => {
      return gr?.canEditPublic === true;
    });
    return IsHaveCanEditPublic?.length > 0 ? true : false;
  }, [data?.groupNormalized])

  const canEditContentCard = React.useMemo(() => {
    if (!!gid && Number(gid) === 0) {
      const IsHaveCanEditPublic =
        !!data?.groupNormalized?.length &&
        data?.groupNormalized?.filter((gr) => {
          return gr?.canEditPublic === true;
        });
      return IsHaveCanEditPublic?.length > 0 ? true : false;
    } else {
      const isHaveCanEdit =
        !!data?.groupNormalized?.length &&
        data?.groupNormalized?.filter((gr) => {
          return gr?.canEdit === true;
        });
      return isHaveCanEdit?.length > 0 ? true : false;
    }
    // }, [JSON.stringify(data)])
  }, [data?.groupNormalized, gid]);

  const { data: data2 } = useSWR(
    !!data
      ? `phenNews-relatedPhen=${JSON.stringify(data)}/${JSON.stringify(
          phenomenonData
        )}`
      : null,
    async () => {
      const [phenomenonNewsRes, relatedPhenomenaRes] = await Promise.all([
        !!phenomenonData?.newsFeeds?.length &&
          getPhenomenonNewsByPhenId(
            phenomenonData?.newsFeeds?.map((feed) => feed?.id),
            [Number(gid), 0]
          ),
        !!data?.phenomenon?.data?.content?.related_phenomena?.length &&
          getPhenomena({
            phenomena: data?.phenomenon?.data?.content?.related_phenomena,
            undefined,
            groups: [0, Number(gid)],
            include_archived: rid ? true : false,
            // , size: data?.phenomenon?.data?.content?.related_phenomena.length
          }),
        // (Number(gid) !== 0) && !!data?.getPhenomenaData?.result?.length && votingApi.getUserName(data?.getPhenomenaData?.result[0]?.updated_by)
      ]);

      return {
        phenomenonNewsRes,
        relatedPhenomenaRes,
      };
    }
  );

  const onOpenPhenEditCard = () => {
    setOpenPhenEditCard(true);
  };

  const onClosePhenEditCard = () => {
    setOpenPhenEditCard(false);
  };

  const relatedPhenomenaData = React.useMemo(() => {
    const newRelated_content =
      !!data2?.relatedPhenomenaRes?.result?.length &&
      data2?.relatedPhenomenaRes?.result?.sort(function (a, b) {
        return (
          data?.phenomenon?.data?.content?.related_phenomena?.indexOf(a?.id) -
          data?.phenomenon?.data?.content?.related_phenomena.indexOf(b?.id)
        );
      });
    const relatedContentsFiltered =
      !!data2?.relatedPhenomenaRes?.result?.length &&
      newRelated_content?.map((r_phen) => {
        const a =
          !!data?.phenomenonType?.length &&
          data?.phenomenonType?.filter(
            (type) => type.id === r_phen?.content?.type
          );

        if (
          !!a?.length &&
          !!a[0] &&
          a[0]?.style &&
          !!a[0]?.style?.color &&
          !!a[0]?.groupType
        ) {
          r_phen["color"] = a[0]?.style?.color;
          r_phen["content-type-alias"] = "undefined";
          r_phen["content-type-title"] = a[0]?.title || a[0]?.label;
        } else {
          r_phen["color"] = "none";
          r_phen["content-type-alias"] = a[0]?.alias;
          r_phen["content-type-title"] = a[0]?.title;
        }
        return r_phen;
      });

    return relatedContentsFiltered;
  }, [data, data2]);

  const phenNews = React.useMemo(() => {
    return data2?.phenomenonNewsRes;
  }, [data2]);

  const completedPhenomenon = React.useMemo(() => {
    let phenTemp = { ...phenomenonData?.content } ?? {};
    phenTemp["color"] =
      !!phenomenonData &&
      !!phenomenonTypeData &&
      !!phenomenonTypeData?.length &&
      !!phenomenonTypeData[0]?.style?.color &&
      phenomenonData?.content?.type?.includes("fp:doc-types")
        ? phenomenonTypeData[0]?.style?.color || "none"
        : "none";
    if (
      phenTemp["color"] === "none" &&
      !phenomenonTypeData?.length &&
      !!phenomenonData?.content?.type?.includes("fp:doc-types")
    ) {
      phenTemp["content-type-alias"] = "undefined";
      phenTemp["content-type-title"] = "(no type)";
    } else {
      phenTemp["content-type-alias"] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.alias;
      phenTemp["content-type-title"] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.title;
    }
    phenTemp["related-phenomena-data"] = relatedPhenomenaData
      ? relatedPhenomenaData
      : null;
    phenTemp["phen-data"] = { ...phenomenonData };
    phenTemp["phenomenonType"] = !!phenomenonTypesData && [
      ...phenomenonTypesData,
    ];
    phenTemp["links"] = !!phenomenonData?.content?.links
      ? [...phenomenonData?.content?.links]
      : null;

    // phenTemp['newsFeeds'] = newsFeed
    phenTemp["newsFeeds"] = phenomenonData?.newsFeeds;

    phenTemp["tags"] =
      data?.getPhenomenaData?.result[0]?.["tags_fp:docs/props/has"] ||
      data?.getPhenomenaData?.result[0]?.["tags"];
    phenTemp["group"] =
      !!phenomenonData?.groups?.length && phenomenonData?.groups[0];
    dispatch({
      type: ACTIONS.TAGS,
      payload: phenTemp?.["tags"],
    });
    isFetchedcompletedPhenomenonDataRef.current = true;
    return phenTemp;
  }, [
    phenomenonData,
    phenomenonTypeData,
    relatedPhenomenaData,
    phenomenonTypesData,
    data?.getPhenomenaData?.result,
    dispatch,
  ]);

  useEffect(() => {
  startTransition(() => {
    const fetchUserGroups = async () => {
      try {
        const res = await votingApi.getUserGroups();
        dispatch({ type: ACTIONS.SET_USER_GROUPS, payload: res?.data });

        // Clone initial groups
        let groups = [...thirdPartyPhenomenaGroupsActived];

        // Using a Set for O(1) lookup of existing IDs
        const existingIds = new Set(groups.map(g => g.id));

        // Parallel fetch phenomena groups
        const allPhenomenaResults = await Promise.all(
          res?.data?.map(group => votingApi.getAllThirdPartyPhenomenaGroups(group.id))
        );

        allPhenomenaResults.forEach(res2 => {
          res2?.data?.phenomena?.forEach(pg => {
            if (!existingIds.has(pg.id)) {
              groups.push(pg);
              existingIds.add(pg.id);
            }
          });
        });

        dispatch({ type: ACTIONS.SET_3RD_PARTY_PHENOMENA_GROUPS, payload: groups });

        const data = groups.map(pg => ({
          label: pg.name,
          name: pg.name,
          value: Number(pg.id),
          id: Number(pg.id),
        }));

        dispatch({ type: ACTIONS.SET_PUBLIC_PHENOMENA_GROUPS, payload: data });
        isFetched3rdPartyPhenomenonDataRef.current = true;
      } catch (error) {
        console.error('Failed to fetch user groups', error);
      }
    };

    !!isFetchedcompletedPhenomenonDataRef.current && !isFetched3rdPartyPhenomenonDataRef.current && fetchUserGroups();
  });
}, [completedPhenomenon, dispatch]);

  useEffect(() => {
    dispatch({
      type: ACTIONS.CONTENTCARDDATA,
      payload: { ...completedPhenomenon },
    });
  }, [completedPhenomenon, dispatch]);

  const ratingsOn = React.useMemo(() => {
    if (!!data?.getRadarData?.ratingsOn) {
      return data?.getRadarData?.ratingsOn;
    }
    return false;
  }, [data?.getRadarData?.ratingsOn]);

  const likingOn = React.useMemo(() => {
    if (!!data?.getRadarData?.likingOn) {
      return data?.getRadarData?.likingOn;
    }
    return false;
  }, [data?.getRadarData?.likingOn]);

  const commentsOn = React.useMemo(() => {
    if (!!data?.getRadarData?.commentsOn) {
      return data?.getRadarData?.commentsOn;
    }
    return false;
  }, [data?.getRadarData?.commentsOn]);

  const votingOn = React.useMemo(() => {
    if (!!data?.getRadarData?.votingOn) {
      return data?.getRadarData?.votingOn;
    }
    return false;
  }, [data?.getRadarData?.votingOn]);
  !!data && !!completedPhenomenon && NProgress.done(true);
  !!data && !!completedPhenomenon && NProgress.remove();
  if (!!error) {
    NProgress.set(1);
    NProgress.done(true);
    NProgress.remove();
  }
  // const history = React.useMemo(() => {
  //   return !!historyLogsState?.length
  //     ? [...historyLogsState]?.sort(function (a, b) {
  //       return a.id - b.id;
  //   })
  //     : [];
  // }, [historyLogsState]);

  const history1Ref = useRef();
  const history2Ref = useRef();
  const history3Ref = useRef();
  const history4Ref = useRef();
  const history5Ref = useRef();
  const history6Ref = useRef();

  const history1Ref1 = useRef();
  const history2Ref1 = useRef();
  const history3Ref1 = useRef();
  const history4Ref1 = useRef();
  const history5Ref1 = useRef();
  const history6Ref1 = useRef();

  const [historytranslations, sethistorytranslations] = useState(null);
  const [history1, sethistory1] = useState(null);
  const [history2, sethistory2] = useState(null);
  const [history3, sethistory3] = useState(null);
  const [history4, sethistory4] = useState(null);
  const [history5, sethistory5] = useState(null);
  const [history6, sethistory6] = useState(null);
  useOnClickOutside(shareWrapperRef, sharedBtnRef, closeSocialBtnsHAndler);

  useEffect(() => {
    const fetcher = async () => {
      const history6Temp = history6 ?? history6Ref1.current;
      const [res1, res2, res3, res4, res5, res6] = await Promise.all([
        !!history1Ref1.current &&
          history1 &&
          votingApi.translation(
            "en",
            langForTransState,
            history1 ?? history1Ref1.current
          ),
        !!history2Ref1.current &&
          history2 &&
          votingApi.translation(
            "en",
            langForTransState,
            history2 ?? history2Ref1.current
          ),
        !!history3Ref1.current &&
          history3 &&
          votingApi.translation(
            "en",
            langForTransState,
            history3 ?? history3Ref1.current
          ),
        (!!history4 || !!history4Ref1.current) &&
          votingApi.translation(
            "en",
            langForTransState,
            history4 ?? history4Ref1.current
          ),
        (!!history5 || !!history5Ref1.current) &&
          votingApi.translation(
            "en",
            langForTransState,
            history5 ?? history5Ref1.current
          ),
        !!history6Temp &&
          (await Promise.all(
            history6Temp?.map((child) => {
              if (!!child) {
                return votingApi.translation(
                  "en",
                  langForTransState,
                  child?.innerHTML
                );
              }
            })
          )),
      ]);

      sethistorytranslations(() => {
        return {
          res1,
          res2,
          res3,
          res4,
          res5,
          res6,
        };
      });
    };
    !!isTranslated && !!history1 && !!history2 && !!history3 && fetcher();
  }, [
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
    isTranslated,
    langForTransState,
  ]);

  useEffect(() => {
    if (!!historyData && !!historyData?.length) {
      if (true) {
        if (!!history1Ref.current?.innerHTML && !history1Ref1.current) {
          history1Ref1.current = history1Ref.current?.innerHTML;
        }
        if (!!history2Ref.current?.innerHTML && !history2Ref1.current) {
          history2Ref1.current = history2Ref.current?.innerHTML;
        }
        if (!!history3Ref.current?.innerHTML && !history3Ref1.current) {
          history3Ref1.current = history3Ref.current?.innerHTML;
        }
        if (!!history4Ref.current?.innerHTML && !history4Ref1.current) {
          history4Ref1.current = history4Ref.current?.innerHTML;
        }
        if (!!history6Ref.current && !history6Ref1.current) {
          const historyList = Array.from(
            document?.querySelectorAll(".firstPartHistoryRow") ?? []
          );

          //////////=>current version code
          history6Ref1.current = historyList;
        }
        // if (!!history6Ref.current?.innerHTML && !history6Ref1.current) {
        //   history6Ref1.current = history6Ref.current?.innerHTML;
        // }
        !!history1Ref1.current &&
          !history1 &&
          sethistory1(() => history1Ref1.current);
        !!history2Ref1.current &&
          !history2 &&
          sethistory2(() => history2Ref1.current);
        !!history3Ref1.current &&
          !history3 &&
          sethistory3(() => history3Ref1.current);
        !!history4Ref1.current &&
          !history4 &&
          sethistory4(() => history4Ref1.current);
        // !!history5Ref1.current &&
        //   !history5 &&
        //   sethistory5(() => history5Ref1.current);
        !!history6Ref1.current &&
          !history6 &&
          sethistory6(() => history6Ref1.current);

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD1,
        //   payload: true
        // })
      }
    }
  }, [
    isTranslated,
    historyData,
    dispatch,
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
  ]);

  const isFirstRendered = useRef(false);
  //   useEffect(() => {
  //     if (!comp7 && !!completedPhenomenon && !!comp4 && !!rid && !ratingsOn && !isFirstRendered.current) {
  //      dispatch({
  //        type: ACTIONS.GETWHOLEHTMLCARD7,
  //        payload: true
  //      })
  //     } else {
  //      if (!rid && !comp7 && !!completedPhenomenon && !!comp4) {
  //        dispatch({
  //          type: ACTIONS.GETWHOLEHTMLCARD7,
  //          payload: true
  //        })
  //      }
  //     }
  //  }, [rid, completedPhenomenon, comp7, dispatch, ratingsOn, comp4])
  //  useEffect(() => {
  //    if (!comp5 && !!completedPhenomenon && !!comp4 && !!rid && !commentsOn && !!cmtRef.current && !isFirstRendered.current) {
  //     dispatch({
  //       type: ACTIONS.GETWHOLEHTMLCARD5,
  //       payload: true
  //     })
  //    } else {
  //     if (!rid && !comp5 && !!completedPhenomenon && !!comp4 && !!cmtRef.current) {
  //       dispatch({
  //         type: ACTIONS.GETWHOLEHTMLCARD5,
  //         payload: true
  //       })
  //     }
  //    }
  // }, [rid, completedPhenomenon, comp5, dispatch, commentsOn, comp4])

  // useEffect(() => {
  //  if (comp3 && comp4 && comp5 && comp6 && comp7 && !comp8  && comp9 &&  comp10 && comp1 &&  comp2 && !isFirstRendered.current) {
  //   if (!!relatedPhenOnAppRef?.current)
  //    dispatch({
  //     type: ACTIONS.GETWHOLEHTMLCARD8,
  //     payload: true
  //   })
  //  }
  // }, [comp3, comp4, comp5, comp6, comp7, comp8, comp9, comp10, comp11, comp1, comp2, dispatch])
  const userId = getUserId();

  const isThisGroupTranslationAllowed = React.useMemo(() => {
    const temp = specialGroupsAllowedTranslation.find(group => group === Number(gid))
    return !!temp
  }, [gid]);

  useEffect(() => {
    // if (!!langForTransState &&  !!isAutoTrans && !!completedPhenomenon &&
    //   (!! comp1 || !historyData?.length)
    //   && (!!comp2 || !completedPhenomenon?.body)
    //   && (!!comp3 || !canEditContentCard)
    //   && !!comp4
    //   && !!comp5
    //   && (!!comp6 || !phenNews?.length)
    //   && (!!comp7)
    //   && (!!comp8 )
    //   && (!!comp9 || !scenariosState?.length)
    //   && (!!comp10 || !completedPhenomenon?.media?.text)
    //   // && (!!comp11 || !data?.getRadarData)
    //   && !isFirstRendered.current
    //   ) {
    //     console.log('case11111111111')
    //     dispatch({
    //       type: ACTIONS.ISTRANSLATED,
    //       payload: true
    //     })
    //     isFirstRendered.current = true
    // }
    // else
    if (
      !!langForTransState &&
      !!isAutoTrans &&
      !!completedPhenomenon &&
      !isTranslated &&
      !isFirstRendered.current &&
      (Number(gid) === 0 || gid === 0 || !!isThisGroupTranslationAllowed)
    ) {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.ISTRANSLATED,
          payload: true,
        });
      }, 2000);
      isFirstRendered.current = true;
    }
  }, [
    completedPhenomenon,
    dispatch,
    isAutoTrans,
    isTranslated,
    langForTransState,
    gid,
    isThisGroupTranslationAllowed
  ]);

  const seletecTransHandler = (e) => {
    const label = e?.target?.innerText;
    const selectedFilter = _.find(langOptionList, {
      label: label,
    });
    if (langForTransTemp === selectedFilter?.value) {
      setlangForTransTemp(() => null);
      setisAutoTransTemp(() => false);
    } else {
      setlangForTransTemp(() => selectedFilter?.value);
    }

    // dispatch({
    //   type: ACTIONS.LANGFORTRANSSTATE,
    //   payload: selectedFilter,
    // });
  };

  const setAutoTransByOnDefaultHandler = () => {
    setisAutoTransTemp(() => !isAutoTransTemp);
    // dispatch({
    //   type: ACTIONS.ISAUTOTRANS,
    //   payload: !isAutoTrans,
    // });
  };
  const cancelSetAutoTransSettingHandler = () => {
    setisOpenTransSettings(false);
    setlangForTransTemp(() => langForTransState);
    setisAutoTransTemp(() => isAutoTrans);
  };
  const doneSetAutoTransSettingHandler = async () => {
    const payload = {
      preferred_language: langForTransTemp ?? null,
      is_auto_translation: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    };

    await votingApi.editPreferredTrans(userId, payload);
    setisOpenTransSettings(false);
    dispatch({
      type: ACTIONS.LANGFORTRANSSTATE,
      payload: langForTransTemp ?? null,
    });
    dispatch({
      type: ACTIONS.ISAUTOTRANS,
      payload: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    });

    // When user clicks Done btn, the content of card should be translated to the target languague,
    // because the user did indicate that he/she wants to translate the card when he/she selected
    // the target lang. So when clicking done, the content card should be translated, but this case
    // is NOT the auto-translation, so should NOT set isAutoTransTemp variable and call editPreferredTrans api
    // with payload is_auto_translation = 1 to set to auto-translation => just translating the content of card.
    if (!!langForTransTemp) {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: true,
      });
    } else {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: false,
      });
    }

    setshouldNotShowPdfExportBtn(true)
  };
  useEffect(() => {
    if (!!shouldNotShowPdfExportBtn) {
      setTimeout(() => {
        setshouldNotShowPdfExportBtn(false)
      }, 5000)
    }
  }, [shouldNotShowPdfExportBtn])
  const newsBookmarkHandler = async () => {
    if (!!isNewsBookMarked) {
      votingApi.deleteBookmarkNews(`${gid || 0}/phenomenon/${pid}`);
    } else {
      votingApi.addBookmarkNews({
        entityUri: `/bookmark/${gid || 0}/phenomenon/${pid}`,
        title: data?.phenomenon?.data?.content?.title,
      });
    }
    setisNewsBookMarked(() => !isNewsBookMarked);
    // mutateContentCard()
  };

  const shareSocialBtnsHandler = (news1, event) => {
    event.preventDefault();
    event.stopPropagation();
    // if (event && event.stopPropagation) event.stopPropagation()

    // event.stopImmediatePropagation()
    // setisOpenSocialBtns(() => !isOpenSocialBtns)
    // setnewsItem(() => news1)

    //open/close this news' modal
    setisSharedModalOpened(() => !isSharedModalOpened);
  };

  const isNotMore495pxWidth = matchMedia("(max-width: 495px)").matches;
  const isNotMore392pxWidth = matchMedia("(max-width: 392px)").matches;

  return (
    <>
    {
      (error ) ? <>
      <ErrorNotice error={error} setError={setError}/>
      </> : (
        <SWRConfig value={{ provider: () => new Map() }}>
      <div ref={mainContentCard} id="content-card-wrapper">
        {!!isOpenTransSettings && (
          <Modal
            isOpen={isOpenTransSettings}
            onRequestClose={() => setisOpenTransSettings(false)}
            style={PhenEditCardStyles}
            ariaHideApp={false}
          >
            <div
              style={{
                padding: "16px",
              }}
            >
              <h3
                style={{
                  marginTop: "1rem",
                }}
              >
                Select you preferred language for translations
              </h3>
              <LangOptWRapper
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {!!langOptionList?.length &&
                  langOptionList?.map((langOpt, i) => {
                    return (
                      <LangOpt
                        key={i}
                        data-value={langOpt?.value}
                        onClick={seletecTransHandler}
                        isSelected={langForTransTemp === langOpt?.value}
                      >
                        {langOpt?.label}
                        {langForTransTemp === langOpt?.value && (
                          <EditButton
                            style={{
                              width: 12,
                            }}
                            src={checked}
                            // onClick={() => {
                            //   dispatch({
                            //     type: ACTIONS.ISTRANSLATED,
                            //     payload: false,
                            //   });
                            // }}
                          />
                        )}
                      </LangOpt>
                    );
                  })}
              </LangOptWRapper>
              {!isPublicShare() ? (
                <AutoTransWrapper>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "calc(50% - 4.6px)",
                  }}
                >
                  <h5
                    style={{
                      margin: 0,
                    }}
                  >
                    Set auto-translations on by default?
                  </h5>
                  <ToggleSwitcher
                    checked={!langForTransTemp ? false : isAutoTransTemp}
                    toggleHandler={setAutoTransByOnDefaultHandler}
                  />
                </div>
                <p
                  style={{
                    fontSize: "13px",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  If you switch this on, all content cards created by the
                  Futures Platform are automatically translated to your
                  preferred language.
                </p>
                {true && (
                  <EditButton
                    style={{
                      height: 14,
                      margin: 0,
                    }}
                    src={g1}
                  />
                )}
              </AutoTransWrapper>
              ) : null}
              
              <CTAsWrapper>
                {/* <AskForMoreLangs className="btn btn-sm btn-outline-secondary">
                ASK FOR MORE LANGUAGES...
              </AskForMoreLangs> */}
                <ContactSupportForm />
                <div>
                  <button
                    style={{
                      boxShadow: "none",
                      border: "none",
                    }}
                    className="btn btn-lg btn-plain-gray"
                    onClick={() => {
                      cancelSetAutoTransSettingHandler();
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    style={{
                      marginLeft: "16px",
                    }}
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                      doneSetAutoTransSettingHandler();
                    }}
                    type="submit"
                  >
                    DONE
                  </button>
                </div>
              </CTAsWrapper>
            </div>
          </Modal>
        )}
        {!!data && (
          <div
            className="container p_4"
            style={{
              background: "#fff",
              color: "#333",
              /* padding: 30px 40px 40px; */
              paddingLeft: "5%",
              paddingRight: "5%",
              // paddingBottom: '4.5%',
              paddingTop: "1rem",
              paddingBottom: 0,
            }}
          >
            <CardHeader
              uri={uri}
              userId={userId}
              langForTransState={langForTransState}
              isTranslated={isTranslated}
              position={position}
              gid={gid}
              rid={rid}
              pid={pid}
              phenomenon={completedPhenomenon}
              lang={langRadar}
              votingOn={votingOn}
              groupRadarId={groupRadarId}
              canEditContentCard={canEditContentCard}
            />

            <div
              style={{
                display: "flex",
                justifyContent:
                  ((Number(gid) === 0 || gid === 0) && langRadar === "en") ||
                  (!!isThisGroupTranslationAllowed) ||
                  (!!rid && !!votingOn)
                    ? "space-between"
                    : "flex-end",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "0.6875rem",
              }}
            >
              {(((Number(gid) === 0 || gid === 0) && langRadar === "en") 
                || !!isThisGroupTranslationAllowed) 
                && (
                <div
                  id="translation-btn-wrapper"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {(langRadar === "en" || !!isThisGroupTranslationAllowed) && (
                    <div
                      data-action-id="phenomenon-translate"
                      data-title={data?.phenomenon?.data?.content?.title}
                      data-translation={langForTransState}
                      data-langtarget={langForTransState}
                      data-uri={uri}
                      id="trans-btn"
                      style={{
                        // height: '24px',
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!isTranslated) {
                          !!langForTransState
                            ? dispatch({
                                type: ACTIONS.ISTRANSLATED,
                                payload: true,
                              })
                            : setisOpenTransSettings(true);

                          !!langForTransState &&
                            setshouldNotShowPdfExportBtn(true)
                        } else {
                          dispatch({
                            type: ACTIONS.ISTRANSLATED,
                            payload: false,
                          });
                        }
                      }}
                    >
                      <TranslationBtn
                        isAuthed={true}
                        isNewsBookMarked={isTranslated}
                        // isNewsBookMarked={isNewsBookMarked}
                      />
                    </div>
                  )}

                  {/* {!isTranslated && langRadar === "en" && (
                <EditButton
                  id='trans-btn'
                  style={{
                    height: '24px'
                  }}
                  data-langtarget={langForTransState}
                  data-uri={uri}
                  src={trans}
                  onClick={() =>
                    !!langForTransState ?
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: true,
                    }) : setisOpenTransSettings(true)
                  }
                />
              )}
              {!!isTranslated && langRadar === "en" && (
                <EditButton
                style={{
                  height: '24px'
                }}
                  src={orginalTrans}
                  onClick={() => {
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: false,
                    });
                  }}
                />
              )} */}
                  {(langRadar === "en" || !!isThisGroupTranslationAllowed) && (
                    <div
                      onClick={() => setisOpenTransSettings(() => true)}
                      style={{
                        marginLeft: "0.25rem",
                      }}
                    >
                      <TranslationDownBtn
                        isAuthed={true}
                        isNewsBookMarked={isOpenTransSettings}
                      />
                    </div>
                  )}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  // width: "7.25rem",
                  width: "fit-content",
                  gap: "0.5rem",
                  marginTop: !!isNotMore392pxWidth ? "0.8125rem" : 0,
                }}
              >
                <div
                  data-action-id="phenomenon-spotlight"
                  data-title={data?.phenomenon?.data?.content?.title}
                  onClick={(e) => {
                    window.open("/spotlight/" + pid + "?content=phenomenon");
                  }}
                >
                  <SpotlightBtn isAuthed={true} isNewsBookMarked={false} />
                </div>
             {
              true && (
                <Tooltip
                placement="bottom-end"
                title={requestTranslation('pdfExportTooltip')}>
                      <div
                      data-action-id="phenomenon-download"
                      data-title={data?.phenomenon?.data?.content?.title}
                  onClick={async (e) => {
                    if (!!shouldNotShowPdfExportBtn || pdfExportLoading)
                      return
                    // Set loading state to true
                    dispatch({
                      type: 'SET_PDF_EXPORT_LOADING',
                      payload: true,
                    })
                    let capturedImage = null;
                    
                    // Only attempt screenshot if we have a valid URL
                    if (statzonChartUrl) {
                      try {
                        const response = await screenshot({ 
                          waitFor: 4000, 
                          url: statzonChartUrl,
                          viewport: { width : 860, height : 600, deviceScaleFactor : 3 }
                        });
                        capturedImage = response.data;
                      } catch (error) {
                        console.error('Error capturing chart screenshot:', error);
                      }
                    }
                    
                

                    let payloadPDFExporter
                    const today = new Date();
                    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    const formattedDate = `${today.getDate()} ${months[today.getMonth()]} ${today.getFullYear()}`;

                    const resFooterTranslationForPDFExporter = !!isTranslated ? await votingApi.translation(
                      "en",
                      langForTransState,
                      "Exported from Futures Platform on " + formattedDate
                    ) : "Exported from Futures Platform on " + formattedDate

                    const isFpGroup =
                    Number(data?.phenomenon?.data?.group) === 0 ||
                    (!!data?.phenomenon?.data?.groups?.length && Number(data?.phenomenon?.data?.groups[0]) === 0);
                    const langcode = isTranslated ? langForTransState : langRadar;

                    if (!isTranslated) {   
                      const { translationTitle } = translatePhenomenonAlias(completedPhenomenon, langRadar);
                     
                      payloadPDFExporter = {
                        "statzon_chart": capturedImage || null,
                        "statzon_chart_url": statzonChartUrl || data?.phenomenon?.data?.content?.media?.statzonChart,
                        is_fp: isFpGroup || false,
                        langcode: langcode,
                        type: 'phenomenon',
                        "subtitle": "PHENOMENON",
                        "title": data?.phenomenon?.data?.content?.title || null,
                        "crowd_source": crowdsourced?.crowdsourced ?? null,
                        "content_type_icon": contentTypeImageSrc?.contentTypeImageSrc || null,
                        "content_type": completedPhenomenon?.["color"] === "none"
                        ? translationTitle
                        : completedPhenomenon?.["content-type-title"] || '',
                          "summary": data?.phenomenon?.data?.content?.summary || null,
                        "image": data?.phenomenon?.data?.content?.media?.image || null,
                        "time_range": !!data?.phenomenon?.data?.content?.time_range?.min ? `${data?.phenomenon?.data?.content?.time_range?.min} - ${data?.phenomenon?.data?.content?.time_range?.max}` : null,
                        "body": data?.phenomenon?.data?.content?.body || null,
                        "export_date": formattedDate,
                        "footer": resFooterTranslationForPDFExporter ||resFooterTranslationForPDFExporter?.data || null,
                        // phenomenon: {
                        //   ...data?.phenomenon?.data,
                        //   contentTypeImageSrc,
                        //   isTranslated: false,
                        //   crowdsourced: crowdsourced,
                        //   isFP: isFP,
                        // }
                      }
                    } else {
                      payloadPDFExporter = {
                        "statzon_chart": capturedImage || null,
                        "statzon_chart_url": statzonChartUrl || data?.phenomenon?.data?.content?.media?.statzonChart,
                        is_fp: isFpGroup || false,
                        langcode: langcode,
                        type: 'phenomenon',
                        "title": dataForTranslationFromCardHeader?.title || null,
                        "subtitle": "PHENOMENON" ,
                        "crowd_source": crowdsourced?.crowdsourced ?? null,
                        "content_type_icon": contentTypeImageSrc?.contentTypeImageSrc || null,
                        "content_type": dataForTranslationFromCardHeader?.typeCardName || null,
                        "summary": dataForTranslationFromCardHeader?.summary || null,
                        "image": data?.phenomenon?.data?.content?.media?.image || null,
                        "time_range": dataForTranslationFromCardHeader?.timeRange || null,
                        "body": dataForTranslationCardBody?.body || null,
                        "export_date": formattedDate,
                        "footer":  resFooterTranslationForPDFExporter?.data || resFooterTranslationForPDFExporter || null,
                        // phenomenon: {
                        //   ...data?.phenomenon?.data,
                        //   isTranslated: true,
                        //   contentTypeImageSrc,
                        //   dataForTranslationFromCardHeader: dataForTranslationFromCardHeader,
                        //   dataForTranslationCardBody: dataForTranslationCardBody,
                        //   crowdsourced: crowdsourced,
                        //   isFP: isFP,
                        // }
                      }
                    }

                    try {
                      const pdfExporterRes = await votingApi.exportPdfReport(payloadPDFExporter);
                      
                      // The PDF should already be opened in a new window by the exportPdfReport function
                      // No need to create a blob and open it again
                      if (!pdfExporterRes.success) {
                        console.error('Failed to export PDF:', pdfExporterRes.error);
                      }
                    } catch (error) {
                      console.error('Error exporting PDF:', error);
                      dispatch({
                        type: 'SET_PDF_EXPORT_LOADING',
                        payload: false,
                      })
                    }

                    dispatch({
                      type: 'SET_PDF_EXPORT_LOADING',
                      payload: false,
                    })
                    
                  }}
                >
                   <PDFBtn
                      isAuthed={true}
                      isNewsBookMarked={pdfExportLoading}
                      isDisabled={!!shouldNotShowPdfExportBtn}
                    />
                </div>
                  </Tooltip>
              )
             }
              

                {/* <div
                  style={{
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                  onClick={(e) => {
                    window.open("/spotlight/" + pid + "?content=phenomenon");
                  }}
                >
                  <ShareBtn isAuthed={true} isNewsBookMarked={false} />
                </div> */}

                {/* <NewsSharesWrapper
                  style={{
                    position: "relative",
                  }}
                >
                  {!!isSharedModalOpened && (
                    <ShareModalWrapper ref={shareWrapperRef}>
                      <SocialSharesWrapper>
                        <SocialShare
                          id="shared-by-linkedin"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-linkedin" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <LinkedinShareButton
                            url={hostname + "/spotlight/" + pid}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-linkedin"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in LinkedIn"
                                : "Jaa LinkedInissäI"}
                            </div>
                          </LinkedinShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-twitter"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-twitter" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <TwitterShareButton
                            url={hostname + "/spotlight/" + pid}
                            title={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-twitter"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Twitter"
                                : "Jaa Twitterissä"}
                            </div>
                          </TwitterShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-facebook"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-facebook" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <FacebookShareButton
                            url={hostname + "/spotlight/" + pid}
                            quote={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-facebook"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Facebook"
                                : "Jaa Facebookissa"}
                            </div>
                          </FacebookShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-email"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-email" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <EmailShareButton
                            IsBodyHtml={true}
                            // url={hostname + '/spotlight/' + newsItem?.id}
                            url={""}
                            subject={`[Shared from FP:] ${data?.phenomenon?.data?.content?.title}`}
                            body={`Hi!

A new way to dive into the news! Click this link to open this article in the Spotlight by Futures Platform:

${hostname}/spotlight/${pid}`}
                            // className="Demo__some-network__share-button"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-mail"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share by Email"
                                : "Jaa Sähköpostitse"}
                            </div>
                          </EmailShareButton>
                        </SocialShare>
                      </SocialSharesWrapper>
                    </ShareModalWrapper>
                  )}
                  <div
                    onClick={(event) =>
                      shareSocialBtnsHandler(data?.phenomenon?.data, event)
                    }
                  >
                    <ShareBtn
                      isAuthed={true}
                      isNewsBookMarked={isSharedModalOpened}
                    />
                  </div>
                </NewsSharesWrapper> */}

                {/* <div onClick={newsBookmarkHandler} ref={sharedBtnRef}>
                  <BookmarkBtn
                    isAuthed={true}
                    isNewsBookMarked={isNewsBookMarked}
                  />
                </div> */}
              </div>

              {!!rid && !!votingOn && (
                <div
                  className={styles.votingWrapper}
                  style={{
                    marginLeft: !!isNotMore495pxWidth ? "auto" : "unset",
                    marginTop: !!isNotMore495pxWidth ? "0.8125rem" : 0,
                    paddingBottom: "0.8125rem",
                  }}
                >
                  {!!rid && position === "left" && !!votingOn && (
                    <Voting
                      gid={gid}
                      rid={rid}
                      pid={pid}
                      groupRadarId={groupRadarId}
                    />
                  )}
                </div>
              )}
            </div>

            <YoutubeImageEmbed
              langForTransState={langForTransState}
              embedId="rokGy0huYEA"
              phenomenon={completedPhenomenon}
              isTranslated={isTranslated}
            />
            <LatestNewsCarousel
              className="latestNewsCarousel-content-card"
              lang={langRadar}
              phenNews={phenNews}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />

            {!!rid && position === "left" && !!ratingsOn && (
              <Rating
                gid={gid}
                rid={rid}
                pid={pid}
                lang={langRadar}
                getRadarData={data?.getRadarData}
                groupRadarId={groupRadarId}
                isTranslated={isTranslated}
                langForTransState={langForTransState}
              />
            )}
            <div ref={cmtRef}>
              {!!rid && position === "left" && (
                <Comments
                  gid={gid}
                  rid={rid}
                  pid={pid}
                  lang={langRadar}
                  phenomenon={completedPhenomenon}
                  commentsOn={commentsOn}
                  likingOn={likingOn}
                  isTranslated={isTranslated}
                  langForTransState={langForTransState}
                />
              )}
            </div>
            <BodyCard
              phenomenon={completedPhenomenon}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />
            {!!completedPhenomenon?.links?.length && (
              <Links phenomenon={completedPhenomenon} lang={langRadar} />
            )}
            <div ref={relatedPhenOnAppRef}>
              <RelatedPhenomena
                langForTransState={langForTransState}
                className="relatedPhenomena-content-card"
                phenomenon={completedPhenomenon}
                gid={gid}
                rid={rid}
                pid={pid}
                lang={langRadar}
                isTranslated={isTranslated}
              />
            </div>
            <RelatedScenarios
              // scenarioSetId={data?.scenarioSet?.id}
              gid={gid}
              relatedScenarios={scenariosState}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />
            {/* <LatestNews
              className="latestNews-content-card"
              phenNews={phenNews}
              lang={langRadar}
            /> */}

            {!!tags?.length && (
              <>
                {/* <div
                  style={{
                    background: '#e8ebeb',
                    width: '100%',
                    height: '2px',
                    marginBottom: '30px',
                  }}></div> */}
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "1.5rem",
                  }}
                >
                  {/* <img
                    style={{
                      marginTop: '5px',
                      marginRight: '12px',
                    }}
                    src={tagIcon}
                  /> */}
                  <PhenomenaTagList
                    scenario={{
                      id: pid,
                      tags: !!tags?.length ? tags : [],
                    }}
                    language={data?.phenomenon?.data?.language}
                    gid={gid}
                  />
                </div>
              </>
            )}



            <div
              className="modal-form-section"
              style={{
                paddingTop: "24px",
                paddingBottom: "24px",
                marginLeft: "-5%",
                marginRight: "-5%",
                paddingLeft: "5%",
                paddingRight: "5%",
                width: "calc(110% + 4px)",
                backgroundColor: "#F6F4F7",
                position: "relative",
              }}
            >
              <HorizontalLine></HorizontalLine>

               

              <Dropdown
                className="dropdown-toggle d-flex align-items-center justify-content-between"
                type="button"
                data-toggle="collapse"
                data-target="#collapsenews"
                aria-expanded="true"
                style={{
                  cursor: "pointer",
                  whiteSpace: "unset",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={handleChangeIconNewsFeedSection}
              >
                <div
                  style={{
                    // maxWidth: '70%',
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {!isTranslated && (
                    <p
                      ref={history1Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    >{`${
                      historyData[0]?.isCreator
                        ? requestTranslation("Created")
                        : requestTranslation("lastModified")
                    } by`}</p>
                  )}
                  {!!isTranslated && (
                    <p
                      ref={history1Ref}
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res1?.data,
                      }}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    ></p>
                  )}

                  <p
                    style={{
                      margin: 0,
                      color: "black",
                      fontWeight: "100",
                      wordBreak: "break-word",
                      marginRight: "2.5px",
                    }}
                  >{`${
                    Number(gid) !== 0
                      ? historyData[0]?.editorName + " "
                      : "Futures Platform "
                  }`}</p>
                  {/* {!isTranslated && (
                    <p
                      ref={history2Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    >
                      on
                    </p>
                  )}
                  {!!isTranslated && (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res2?.data,
                      }}
                      ref={history2Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                        textTransform: "lowercase",
                      }}
                    ></p>
                  )} */}
                  <p
                    style={{
                      margin: 0,
                      color: "black",
                      fontWeight: "100",
                      wordBreak: "break-word",
                    }}
                  >{`${historyData[0]?.date}`}</p>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  {!isTranslated && (
                    <p
                      ref={history3Ref}
                      style={{
                        margin: 0,
                        marginRight: "4px",
                        fontWeight: "100",
                        width: "fit-content",
                      }}
                    >
                      {iconNewsFeedSection === "expand_more"
                        ? requestTranslation("ShowHistory")
                        : requestTranslation("HideHistory")}
                    </p>
                  )}
                  {!!isTranslated && (
                    <p
                      ref={history3Ref}
                      style={{
                        margin: 0,
                        marginRight: "4px",
                        fontWeight: "100",
                        width: "fit-content",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res3?.data,
                      }}
                    ></p>
                  )}
                  <i className="material-icons">{iconNewsFeedSection}</i>
                </div>
              </Dropdown>
              <div id="collapsenews" className="collapse mt-4">
                {!isTranslated && (
                  <h3 className="mb-4" ref={history4Ref}>
                    {requestTranslation("Historyandchangelog")}
                    {/* <DropdownValue></DropdownValue> */}
                  </h3>
                )}
                {!!isTranslated && (
                  <h3
                    className="mb-4"
                    ref={history4Ref}
                    dangerouslySetInnerHTML={{
                      __html: historytranslations?.res4?.data,
                    }}
                  ></h3>
                )}
                {!!historyData?.length &&
                  historyData?.map((history, i) => {
                    return (
                      <>
                        {!!history?.isShown && (
                          <div
                            key={i}
                            style={{
                              marginBottom: "16px",
                              marginLeft: "24px",
                              display: "flex",
                              flexWrap: "wrap",
                            }}
                          >
                            {!isTranslated && (
                              <p
                                ref={history6Ref}
                                className="firstPartHistoryRow"
                                style={{
                                  margin: 0,
                                  color: "#637282",
                                  marginRight: "2.5px",
                                }}
                              >{`${
                                history?.isCreator
                                  ? requestTranslation("Created")
                                  : requestTranslation("Edited")
                              } ${requestTranslation("on")} ${
                                history?.date
                              }  ${requestTranslation("by")}`}</p>
                            )}
                            {!!isTranslated && (
                              <p
                                ref={history6Ref}
                                dangerouslySetInnerHTML={{
                                  __html: historytranslations?.res6?.[i]?.data,
                                }}
                                style={{
                                  margin: 0,
                                  color: "#637282",
                                  marginRight: "2.5px",
                                }}
                              ></p>
                            )}
                            <p
                              style={{
                                margin: 0,
                                color: "#637282",
                                marginRight: "3px",
                              }}
                            >{`${
                              Number(gid) !== 0
                                ? history?.editorName
                                : "Futures Platform"
                            }`}</p>

                            <p
                              // ref={history5Ref}
                              style={{
                                margin: 0,
                                fontWeight: 500,
                              }}
                            >
                              {history?.description}
                            </p>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
              {
                isFPEditorRole && data?.phenomenon?.data?.update_recomendation ? (
                  <div 
                  className="card-update-recommendation"
                  style={{
                  paddingTop: '2rem',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      justifyContent: 'center'}}>
                      <p style={{
                        // fontSize: '20px',
                        margin: 0,
                        fontWeight: '400',
                        marginBottom: 0,
                      }}>
                        {
                        requestTranslation("update_recomendation")
                      }
                      </p>
                      {data?.phenomenon?.data?.update_recomendation?.date && 
                        (() => {
                          const date = new Date(data['phenomenon'].data.update_recomendation.date);
                          const time = date.toLocaleTimeString('en-GB', { 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            second: '2-digit' 
                          });
                          const day = date.getDate().toString().padStart(2, '0');
                          const month = (date.getMonth() + 1).toString().padStart(2, '0');
                          const year = date.getFullYear();
                          return `${day}.${month}.${year}`;
                        })()
                      }
                    </div>
                    <div 
                    className="card-header-update-recommendation-toggle"
                    onClick={() => setisExpandedUpdateRecommended(!isExpandedUpdateRecommended)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      cursor: 'pointer'
                    
                    }}>
                      {
                        !isExpandedUpdateRecommended ? requestTranslation("expand_more_UpdateRecommended") : requestTranslation("expand_less_UpdateRecommended")
                      }
                      {
                      !isExpandedUpdateRecommended ? (<div><i class="material-icons">expand_more</i></div>) : (<div><i class="material-icons">expand_less</i></div>)
                    }
                    </div>
                  </div>
                   <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                   }}>
                      <div style={{
                        borderRadius: '50%',
                        width: '1rem',
                        height: '1rem',
                        backgroundColor: data?.phenomenon?.data?.update_recomendation?.status === 2 ? '#E95757' : (data?.phenomenon?.data?.update_recomendation?.status === 1 ? '#ECAF3F' : '#6FBF40')
                      }}></div>
                     <p style={{ margin: 0 }}>{data?.phenomenon?.data?.update_recomendation?.status === 2 ? "Update recommended" : (data?.phenomenon?.data?.update_recomendation?.status === 1 ? 'Might need a check' : 'Looks good')}</p>
                   </div>

                  {
                    isExpandedUpdateRecommended ? (
                      <div style={{
                        // backgroundColor: '#f8f9fa',
                        padding: '1rem',
                        // borderRadius: '8px',
                        // border: '1px solid #e9ecef',
                        // marginTop: '15px',
                        maxHeight: '600px',
                        overflowY: 'auto',
                        fontSize: '14px',
                        lineHeight: '1.6',
                        paddingTop: '0.65rem',
                      
                        // color: '#333'
                      }}>
                        <div 
                          className="markdown-content"
                          style={{
                            /* Auto-format markdown content with clean spacing */
                          }}
                        >
                          <style dangerouslySetInnerHTML={{
                            __html: `
                              .card-update-recommendation .markdown-content h1 {
                                font-size: 1.1rem !important;
                                font-weight: bold !important;
                                margin: 28px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content h2 {
                                font-size: 1.05rem !important;
                                font-weight: bold !important;
                                margin: 26px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content h3 {
                                font-size: 1rem !important;
                                font-weight: bold !important;
                                margin: 24px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content h4 {
                                font-size: 0.95rem !important;
                                font-weight: bold !important;
                                margin: 22px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content h5 {
                                font-size: 0.9rem !important;
                                font-weight: bold !important;
                                margin: 20px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content h6 {
                                font-size: 0.85rem !important;
                                font-weight: bold !important;
                                margin: 18px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content p {
                                margin: 4px 0 0 0 !important;
                                line-height: 1.5 !important;
                              }
                              .card-update-recommendation .markdown-content ul, 
                              .card-update-recommendation .markdown-content ol {
                                margin: 12px 0 0 0 !important;
                                padding-left: 18px !important;
                              }
                              .card-update-recommendation .markdown-content li {
                                margin: 6px 0 0 0 !important;
                                line-height: 1.4 !important;
                              }
                              .card-update-recommendation .markdown-content li p {
                                margin: 3px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content blockquote {
                                margin: 10px 0 0 0 !important;
                                padding-left: 12px !important;
                                border-left: 3px solid #007bff !important;
                                font-style: italic !important;
                              }
                              .card-update-recommendation .markdown-content pre {
                                margin: 10px 0 0 0 !important;
                                padding: 8px !important;
                                background-color: #f1f3f4 !important;
                                border-radius: 4px !important;
                                overflow: auto !important;
                                font-family: monospace !important;
                              }
                              .card-update-recommendation .markdown-content code {
                                background-color: #f1f3f4 !important;
                                padding: 1px 3px !important;
                                border-radius: 2px !important;
                                font-family: monospace !important;
                              }
                              .card-update-recommendation .markdown-content hr {
                                margin: 20px 0 0 0 !important;
                                border: none !important;
                                border-top: 1px solid #dee2e6 !important;
                              }
                              .card-update-recommendation .markdown-content a {
                                text-decoration: underline !important;
                              }
                              .card-update-recommendation .markdown-content strong {
                                font-weight: bold !important;
                              }
                              .card-update-recommendation .markdown-content em {
                                font-style: italic !important;
                              }
                              
                              /* Override for proper hierarchy: h4 > ol > li spacing */
                              .card-update-recommendation .markdown-content h4 + ol,
                              .card-update-recommendation .markdown-content h4 + ul {
                                margin: 8px 0 0 0 !important;
                              }
                              
                              /* Main numbered sections get medium spacing */
                              .card-update-recommendation .markdown-content ol > li {
                                margin: 10px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content ol > li:first-child {
                                margin: 6px 0 0 0 !important;
                              }
                              
                              /* Sub-bullets within sections get tight spacing */
                              .card-update-recommendation .markdown-content ol > li ul,
                              .card-update-recommendation .markdown-content ol > li ol {
                                margin: 4px 0 0 0 !important;
                              }
                              .card-update-recommendation .markdown-content ol > li ul > li,
                              .card-update-recommendation .markdown-content ol > li ol > li {
                                margin: 3px 0 0 0 !important;
                              }
                            `
                          }} />
                          <Markdown>
                            {data?.phenomenon?.data?.update_recomendation?.reason}
                          </Markdown>
                        </div>
                      </div>
                    ) : null
                  }
                </div>
                ) : null
              }
              <CardFooter
                isTranslated={isTranslated}
                langForTransState={langForTransState}
                data={data}
                lang={langRadar}
                onOpenPhenEditCard={onOpenPhenEditCard}
                canEditContentCard={canEditContentCard}
                gid={gid}
                // lastesEditor={data2?.latestEditorName?.data?.displayName}
              />
            </div>

            {!!openPhenEditCard && (
              <Modal
                isOpen={openPhenEditCard}
                onRequestClose={onClosePhenEditCard}
                style={PhenEditCardStyles}
                ariaHideApp={false}
              >
                <PhenomenonEditForm
                  // phenomenon={completedPhenomenon?.['phen-data']?.content}
                  historyData={historyData}
                  isFPEditorRole={isFPEditorRole}
                  relatedScenarios={scenariosState}
                  radar={completedPhenomenon}
                  gid={gid}
                  rid={rid}
                  pid={pid}
                  groupNormalized={data?.groupNormalized}
                  urlSWR={`getAllCommentsByPhenId=${
                    groupIdUsed || groupRadarId
                  }/${rid}/${pid}`}
                  mutateContentCard={mutateContentCard}
                  onSubmit={() => {}}
                  basePhenomenon={{}}
                  phenomenonData={phenomenonData}
                  onCancel={onClosePhenEditCard}
                />
              </Modal>
            )}
          </div>
        )}
      </div>
    </SWRConfig>
      )
    }
    </>
  );
};
export default App;

const HorizontalLine = styled.div`
  margin-left: calc(-5% - 4px);
  margin-right: calc(-5% - 4px);
  width: calc(100% + 8px);
  height: 2px;
  position: absolute;
  top: 0;
  background-color: #dedede;
`;
export const LangOptWRapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const LangOpt = styled.div`
  // isSelected #5ea236
  font-weight: 400;
  color: ${(props) => (!!props.isSelected ? "white" : "black")};
  background: ${(props) => (!!props.isSelected ? "#6fbf40" : "transparent")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(50% - 4.6px);
  border: 1px solid rgb(118 118 118 / 50%);
  padding: 14px;
  margin-bottom: 6px;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 14px;
  font-family: L10, Roboto, "Helvetica Neue", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  &:nth-child(odd) {
    margin-right: 3px;
  }
  &:nth-child(even) {
    margin-left: 3px;
  }
  :hover {
    background: ${(props) => (!!props.isSelected ? "#5ea236" : "#aaaaaa36")};
  }
`;

export const EditButton = styled.img`
  cursor: pointer;
  margin-left: 16px;
  height: 24px;
  :hover {
    opacity: 0.8;
  }
`;
export const AutoTransWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const CTAsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const NewsSharesWrapper = styled.div`
  width: fit-content;
  height: fit-content;
`;

const ShareModalWrapper = styled.div`
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  z-index: 11111;
  position: absolute;
  width: fit-content;
  height: fit-content;
  font-size: 1rem;
  left: 0;
  background: #fafafa;
  color: #212529;
  top: 100%;
  background-clip: padding-box;
  border: 0 solid #e9e9e9;
  border-radius: 0;
  margin: 1px 0 0;
  padding: 8px 16px 8px 12px;
  padding-bottom: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const SocialSharesWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: column;
`;

const SocialShare = styled.div`
  margin: 8px;
  white-space: nowrap;
  overflow: hidden;
`;
const EmailBtn = styled.span`
  &::before {
    padding: 10px;
  }
  color: rgb(0, 0, 0);
`;
